<template>
  <div ref="diagramDiv" class='flowchart'></div>
</template>

<script>
  import * as go from "gojs";

  export default {
    name: "Flowchart",
    props: {
      diagramData: {
        type: Object,
        default: () => {}
      }
    },
    mounted() {
      this.initDiagram();
    },
    methods: {
      initDiagram() {
        const $ = go.GraphObject.make;

        const diagram = $(go.Diagram, this.$refs.diagramDiv, {
          initialContentAlignment: go.Spot.Center,
          contentAlignment: go.Spot.Center,
          "undoManager.isEnabled": true,
          layout: $(go.TreeLayout, {
            angle: 0,
            rowSpacing: 50,
            nodeSpacing: 50,
            setsPortSpot: false,
            setsChildPortSpot: false,
            layerSpacing: 50
          })
        });

        diagram.nodeTemplate = $(
          go.Node,
          "Auto",
          $(go.Shape, "RoundedRectangle", { strokeWidth: 0 },
            new go.Binding("fill", "color")),
          $(go.TextBlock, { margin: 8 },
            new go.Binding("text", "text"))
        );

        diagram.linkTemplate = $(
          go.Link,
          $(go.Shape),
          $(go.Shape, { toArrow: "Standard" }),
          $(
            go.Panel,
            "Auto",
            { visible: false },
            new go.Binding("visible", "text", function(t) {
              return !!t;
            }),
            $(go.Shape, { fill: "white", strokeWidth: 0 }),
            $(go.TextBlock, { margin: 4 },
              new go.Binding("text", "text"))
          )
        );

        diagram.model = new go.GraphLinksModel(this.diagramData.nodeDataArray, this.diagramData.linkDataArray);
      }
    }
  };
</script>

<style scoped>
  .flowchart {
    width: 100%;
    height: 300px;
    max-height: 300px;
    position: relative;
  }
  /* Optionally add some styling */
</style>
